

























import { Component, Vue } from 'vue-property-decorator';
import CompanyMixin from '@/mixins/CompanyMixin';
import ExtendedCompass from '@/components/ExtendedCompass.vue';

@Component({ mixins: [CompanyMixin], components: {ExtendedCompass} })
export default class CardCompassNew extends Vue {
}

